export default __webpack_public_path__ + "static/media/build-edge-logo.2ac45cfc.svg";